// extracted by mini-css-extract-plugin
export default {"container":"AdminConfigTractorBooms_container__XAR9-"};